import {Component, Inject, Input, OnInit} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {ConfService} from '../../conf.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {environment} from '../../../environments/environment';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatTableDataSource} from '@angular/material';
import {Router} from '@angular/router';
import {KongService} from '../../kong.service';
import * as CryptoJS from 'crypto-js';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
  selector: 'app-email-settings',
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.scss']
})
export class EmailSettingsComponent implements OnInit {
  items: any;

  displayedColumns = ['selection', 'serverName', 'userName', 'password', 'host', 'port', 'protocol', 'emails', 'add'];
  dataSource: any;
  selectedElement: any;

  type = 'data';
  attribute = 'configurations.emailServerConfigurations';
  addbuttontext = 'Add Email Settings';
  schema: any;
  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  emailService: any;
  serviceOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
      'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
      'Access-Control-Allow-Origin': '*',
      'observe': 'response'
    })
  };
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  loading = true;

  passphrase = environment.cipheringPhrase;
  iterationCount = 1000;
  keySize = 128 / 32;

  constructor(public settingComp: SettingsComponent,
              private appComp: AppComponent,
              public confPost: ConfService,
              public _service: ConnecttocrudService,
              public platform: LeftpanelComponent,
              public accountInfoService: AccountInfoService,
              private dialog: MatDialog) { }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.dataSource = new MatTableDataSource([]);
    let services: any;
    this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(data => {
      this.platform.adminSettingsData = data;
      if (data && data['body']) {
        for (const env of data['body'][0]['environments']) {
          if (env && env !== null && env !== undefined) {
            if (env['name'] === this.partner) {
              services = env['services'];
            }
          }
        }
        if ((services.filter(element => element.name === 'Email Configurations')).length === 0) {
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined) {
              env['services'].push({name: 'Email Configurations', type: 'emailConfigurations', configurations: []});
            }
          }
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined && env['name'] !== 'admin') {
              this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response => {
                if (response && response['body']) {
                  for (const env1 of response['body'][0]['environments']) {
                    if (env1 && env1 !== null && env1 !== undefined) {
                      env1['services'].push({name: 'Email Configurations', type: 'emailConfigurations', configurations: []});
                    }
                  }
                  this.platform.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).then(resp1 => {});
                }
              });
            }
          }
          this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(data1 => {
            if (data1 && data1 !== null && data1 !== undefined) {
              this.platform.adminSettingsData = data1;
              this.items = {
                'sourcetype': this.type,
                // 'data': data[0]['configurations']['emailServerConfigurations'],
                'patchUrl': environment.apihost + '/v1/data/services/services/settings/' + data1['body'][0]['id'],
                'headers': this.serviceOptions
              };
              for (const env of data1['body'][0]['environments']) {
                if (env && env !== null && env !== undefined) {
                  if (env['name'] === this.partner) {
                    services = env['services'];
                  }
                }
              }
              services.filter(async service => {
                if (service.name === 'Email Configurations') {
                  const configArray = [];
                  for (const config of service['configurations']) {
                    const attributes = Object.keys(config);
                    const configData = {};
                    for (const key of attributes) {
                      if (key === 'username' || key === 'password' || key === 'host') {
                        await this.platform.decryptAttribute(config['shash'], config['ralam'], this.passphrase, config[key], this.keySize, this.iterationCount).then(response => {
                          configData[key] = response;
                        });
                      } else {
                        configData[key] = config[key];
                      }
                    }
                    configArray.push(configData);
                  }
                  this.items['data'] = configArray;
                }
              });
              this.loading = false;
            }
          }, error => {
            this.loading = false;
          });
        } else {
          this.items = {
            'sourcetype': this.type,
            // 'data': data[0]['configurations']['emailServerConfigurations'],
            'patchUrl': environment.apihost + '/v1/data/services/services/settings/' + data['body'][0]['id'],
            'headers': this.serviceOptions
          };
          this.updateTable(services);
          this.loading = false;
        }
      }
    }, error => {
      this.loading = false;
    });
    this.confPost.getEntity('services', 'services', 'settings', 'v1').subscribe(data => {
      this.schema = data['attributes'][2]['subType'][2]['subType'];
    });
  }

  changeDefault(event, emailArray, i) {
    for (const val of emailArray) {
      val.is_default = false;
    }
    emailArray[i].is_default = true;
    this.dataSource.data = emailArray;
    const data = this.platform.adminSettingsData;
    if (data && data['body']) {
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
      let index = 0;
      for (const env of data['body'][0]['environments']) {
        if (env && env !== null && env !== undefined && env['name'] !== 'admin') {
          this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response => {
            if (response && response['body']) {
              for (const env1 of response['body'][0]['environments']) {
                if (env1 && env1 !== null && env1 !== undefined) {
                  env1['services'].filter(service => {
                    if (service.name === 'Email Configurations' ) {
                      service['configurations'].forEach(function (item, idx) {
                        if (idx === i) {
                          item.is_default = true;
                        } else {
                          item.is_default = false;
                        }
                      });
                    }
                  });
                }
              }
              this.platform.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).then(resp1 => {
                index += 1;
                if (index === data['body'][0]['environments'].length) {
                  this.platform.openSnackBar('Default Server set successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                  this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(data1 => {
                    let services: any;
                    this.platform.adminSettingsData = data1;
                    for (const env of data1['body'][0]['environments']) {
                      if (env && env !== null && env !== undefined) {
                        if (env['name'] === this.partner) {
                          services = env['services'];
                          this.updateTable(services);
                        }
                      }
                    }
                  });
                  loaderDialog.close();
                }
              });
            }
          }, error => {
            loaderDialog.close();
          });
        }
      }
    }

  }

  updateTable(services) {
      services.filter(async service => {
        if (service.name === 'Email Configurations') {
          const configArray = [];
          for (const config of service['configurations']) {
            const attributes = Object.keys(config);
            const configData = {};
            for (const key of attributes) {
              if (key === 'username' || key === 'password' || key === 'host') {
                await this.platform.decryptAttribute(config['shash'], config['ralam'], this.passphrase, config[key], this.keySize, this.iterationCount).then(response => {
                  configData[key] = response;
                });
              } else if (key === 'fromEmailConfigurations') {
                configData[key] = [];

                for (const email of config[key]) {
                  const attributes1 = Object.keys(email);
                  const obj = JSON.parse(JSON.stringify(email));
                  for (const key1 of attributes1) {
                    if (key1 === 'sender_name' || key1 === 'sender_email') {
                      await this.platform.decryptAttribute(config['shash'], config['ralam'], this.passphrase, email[key1], this.keySize, this.iterationCount).then(response => {
                        obj[key1] = response;
                      });
                    }
                  }
                  configData[key].push(obj);
                }
              } else {
                configData[key] = config[key];
              }
            }
            configArray.push(configData);
          }
          this.items['data'] = configArray;
          this.dataSource.data = this.items['data'];
        }
      });
  }

  addConfiguration() {
    const configuration = {
      constraintName: '',
      columnMappings: [],
      referenceTable: '',
      onDelete: 'NO ACTION',
      onUpdate: 'NO ACTION'
    };

    let defaultFound = false;
    if (this.items['data']) {
      for (const item of this.items['data']) {
        if (item.is_default) {
          defaultFound = true;
          break;
        }
      }
    }
    const addConfigurationDialog = this.dialog.open(AddEmailConfigurationComponent, {
      width: '60vw',
      height: 'auto',
      data: {
        configuration: {
          server_name: '',
          username: '',
          password: '',
          host: '',
          port: 0,
          protocol: '',
          fromEmailConfigurations: [
            {
              sender_email: '',
              sender_name: '',
              is_default: true
            }
          ],
          is_default: !defaultFound
        },
        isEdit: false,
        partner: this.partner,
        account: this.account
      }
    });

    addConfigurationDialog.afterClosed().subscribe(response => {
      if (response && response !== null && response !== undefined && response === 'success') {
        let services: any;
        this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(data => {
          this.platform.adminSettingsData = data;
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined) {
              if (env['name'] === this.partner) {
                services = env['services'];
                this.updateTable(services);
              }
            }
          }
        });
      }
    });
  }

  editConfiguration(index) {
    const configuration = {
      constraintName: '',
      columnMappings: [],
      referenceTable: '',
      onDelete: 'NO ACTION',
      onUpdate: 'NO ACTION'
    };
    const editConfigurationDialog = this.dialog.open(AddEmailConfigurationComponent, {
      width: '60vw',
      height: 'auto',
      data: {
        configuration: {
          server_name: this.items['data'][index]['server_name'],
          username: this.items['data'][index]['username'],
          password: this.items['data'][index]['password'],
          host: this.items['data'][index]['host'],
          port: this.items['data'][index]['port'],
          protocol: this.items['data'][index]['protocol'],
          fromEmailConfigurations: this.items['data'][index]['fromEmailConfigurations'] ? JSON.parse(JSON.stringify(this.items['data'][index]['fromEmailConfigurations'])) : [],
          is_default: this.items['data'][index]['is_default'] ? this.items['data'][index]['is_default'] : false,
        },
        isEdit: true,
        index: index,
        partner: this.partner,
        account: this.account
      }
    });

    editConfigurationDialog.afterClosed().subscribe(response => {
      if (response && response !== null && response !== undefined && response === 'success') {
        let services: any;
        this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(data => {
          this.platform.adminSettingsData = data;
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined) {
              if (env['name'] === this.partner) {
                services = env['services'];
                this.updateTable(services);
              }
            }
          }
        });
      }
    });
  }

  removeConfiguration(i) {
    if (confirm('This action is irreversible. Do you want to continue ?')) {
      const data = this.platform.adminSettingsData;
      if (data && data['body']) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
          maxWidth: '95vw',
          maxHeight: '60vh',
        });
        let index = 0;
        for (const env of data['body'][0]['environments']) {
          if (env && env !== null && env !== undefined && env['name'] !== 'admin') {
            this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response => {
              if (response && response['body']) {
                for (const env1 of response['body'][0]['environments']) {
                  if (env1 && env1 !== null && env1 !== undefined) {
                    env1['services'].filter(service => {
                      if (service.name === 'Email Configurations' ) {
                        let defaultTBC = false;
                        if (service['configurations'][i].is_default) {
                          defaultTBC = true;
                        }
                        service['configurations'].splice(i, 1);

                        if (defaultTBC && service['configurations'].length > 0) {
                          service['configurations'][0].is_default = true;
                        }
                      }
                    });
                  }
                }
                this.platform.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).then(resp1 => {
                  index += 1;
                  if (index === data['body'][0]['environments'].length) {
                    this.platform.openSnackBar('Email Configuration deleted successfully', 'Success', {
                      duration: 5000,
                      verticalPosition: 'top',
                      horizontalPosition: 'center'
                    });
                    this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(data1 => {
                      let services: any;
                      this.platform.adminSettingsData = data1;
                      for (const env of data1['body'][0]['environments']) {
                        if (env && env !== null && env !== undefined) {
                          if (env['name'] === this.partner) {
                            services = env['services'];
                            this.updateTable(services);
                          }
                        }
                      }
                    });
                    loaderDialog.close();
                  }
                });
              }
            }, error => {
              loaderDialog.close();
            });
          }
        }
      }
    }
  }

  testConfiguration(i) {
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
    });
    return new Promise((resolve, reject) => {
      this.confPost.testEmailServerConfigurations('3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc', this.items['data'][i]).subscribe(response => {
        if (response && response.status && response.status === 200) {
          this.platform.openSnackBar('Test successful', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
        loaderDialog.close();
      }, error => {
        loaderDialog.close();
        this.platform.handleErrorGracefully(error, 'Test failed. Check the configuration, details');
      });
    });
  }

}

export interface FromEmail {
  sender_email: string;
  sender_name: string;
  is_default: boolean;
}

@Component({
  selector: 'add-email-configuration',
  templateUrl: 'add-email-configuration.component.html',
  styleUrls: ['add-email-configuration.component.css']
})
export class AddEmailConfigurationComponent implements OnInit {

  selectable = true;
  removable = true;
  addOnBlur = true;

  passphrase = environment.cipheringPhrase;
  iterationCount = 1000;
  keySize = 128 / 32;
  displayedColumns = ['selection', 'email', 'from', 'add'];
  dataSource: any;
  selectedElement: FromEmail;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public platform: LeftpanelComponent,
              public dialogRef: MatDialogRef<AddEmailConfigurationComponent>,
              public confPost: ConfService,
              public router: Router,
              public accountInfoService: AccountInfoService) {
    dialogRef.disableClose = true;


    this.dataSource = new MatTableDataSource(data['configuration']['fromEmailConfigurations']);

    for (const val of data['configuration']['fromEmailConfigurations']) {
      if (val.is_default) {
        this.selectedElement = val;
      }
    }
  }

  ngOnInit() {

  }

  add(event, data): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      data.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(val, data): void {
    const index = data.indexOf(val);

    if (index >= 0) {
      data.splice(index, 1);
    }
  }

  close() {
    this.dialogRef.close();
  }

  addEmail(emailArray) {
    emailArray.push({
      sender_email: '',
      sender_name: '',
      is_default: emailArray.length === 0,
    });

    this.dataSource.data = emailArray;
  }

  removeEmail(emailArray, index) {
    const isDefault = emailArray[index].is_default;
    emailArray.splice(index, 1);
    if (emailArray.length > 0 && isDefault) {
     if (emailArray.length - 1 >= index) {
       emailArray[index].is_default = true;
     } else {
       emailArray[index - 1].is_default = true;
     }
    }
    this.dataSource.data = emailArray;
  }

  changeDefault(event, emailArray, index) {
    for (const val of emailArray) {
      val.is_default = false;
    }

    emailArray[index].is_default = true;

    this.dataSource.data = emailArray;
  }

  testConfiguration() {
    this.clearIncompleteFromAddresses();
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
    });
    return new Promise((resolve, reject) => {
      this.confPost.testEmailServerConfigurations('3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc', this.data['configuration']).subscribe(response => {
        if (response && response.status && response.status === 200) {
          this.platform.openSnackBar('Test successful', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
        loaderDialog.close();
      }, error => {
        loaderDialog.close();
        this.platform.handleErrorGracefully(error, 'Test failed. Check the configuration, details');
      });
    });
  }

  clearIncompleteFromAddresses() {
    this.data['configuration']['fromEmailConfigurations'] = this.data['configuration']['fromEmailConfigurations'].filter(item => (item.sender_email && item.sender_email !== '' && item.sender_name && item.sender_name !== ''));
    let defaultFound = false;
    for (const val of this.data['configuration']['fromEmailConfigurations']) {
      if (val.is_default) {
        defaultFound = true;
        break;
      }
    }
    if (!defaultFound) {
      if (this.data['configuration']['fromEmailConfigurations'].length > 0) {
        this.data['configuration']['fromEmailConfigurations'][0].is_default = true;
      }
    }
    this.dataSource.data = this.data['configuration']['fromEmailConfigurations'];
  }

  async addConfiguration() {
    this.clearIncompleteFromAddresses();
    if (this.data['configuration']['server_name'] !== '' && this.data['configuration']['server_name'] !== null && this.data['configuration']['server_name'] !== undefined
        && this.data['configuration']['username'] !== '' && this.data['configuration']['username'] !== null && this.data['configuration']['username'] !== undefined
        && this.data['configuration']['password'] !== '' && this.data['configuration']['password'] !== null && this.data['configuration']['password'] !== undefined
        && this.data['configuration']['host'] !== '' && this.data['configuration']['host'] !== null && this.data['configuration']['host'] !== undefined
        && this.data['configuration']['port'] !== null && this.data['configuration']['port'] !== undefined
        && this.data['configuration']['protocol'] !== '' && this.data['configuration']['protocol'] !== null && this.data['configuration']['protocol'] !== undefined) {
      if (this.data['configuration']['fromEmailConfigurations'].length > 0) {
        const data = this.platform.adminSettingsData;
        if (data && data['body']) {
          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
          });

          const payload = {};

          const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          payload['shash'] = salt;
          payload['ralam'] = iv;
          const attributes = Object.keys(this.data['configuration']);
          for (const key of attributes) {
            if (key === 'username' || key === 'password' || key === 'host') {
              await this.platform.encryptAttribute(salt, iv, this.passphrase, this.data['configuration'][key], this.keySize, this.iterationCount).then(response => {
                payload[key] = response;
              });
            } else if (key === 'fromEmailConfigurations') {
              payload[key] = [];

              for (const email of this.data['configuration'][key]) {
                const attributes1 = Object.keys(email);
                const obj = JSON.parse(JSON.stringify(email));
                for (const key1 of attributes1) {
                  if (key1 === 'sender_name' || key1 === 'sender_email') {
                    await this.platform.encryptAttribute(salt, iv, this.passphrase, obj[key1], this.keySize, this.iterationCount).then(response => {
                      obj[key1] = response;
                    });
                  }
                }
                payload[key].push(obj);
              }
            } else {
              payload[key] = this.data['configuration'][key];
            }

          }

          let index = 0;
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined && env['name'] !== 'admin') {
              this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response => {
                if (response && response['body']) {
                  for (const env1 of response['body'][0]['environments']) {
                    if (env1 && env1 !== null && env1 !== undefined) {
                      let configFound = false;
                      env1['services'].filter(service => {
                        if (service.name === 'Email Configurations') {
                          configFound = true;
                          service['configurations'].push(payload);
                        }
                      });
                      if (!configFound) {
                        env1['services'].push({
                          'name': 'Email Configurations',
                          'type': 'emailConfigurations',
                          'configurations': [payload]
                        });
                      }
                    }
                  }


                  this.platform.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).then(resp1 => {
                    index += 1;
                    if (index === data['body'][0]['environments'].length) {
                      this.platform.openSnackBar('Email Configuration added successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                      });
                      loaderDialog.close();
                      this.dialogRef.close('success');
                    }
                  });
                }
              }, error => {
                loaderDialog.close();
              });
            }
          }
        }
      } else {
        this.platform.openSnackBar('Please configure at least one From Email Address.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.platform.openSnackBar('Please fill all the required attributes.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  async editConfiguration() {
    this.clearIncompleteFromAddresses();
    if (this.data['configuration']['server_name'] !== '' && this.data['configuration']['server_name'] !== null && this.data['configuration']['server_name'] !== undefined
        && this.data['configuration']['username'] !== '' && this.data['configuration']['username'] !== null && this.data['configuration']['username'] !== undefined
        && this.data['configuration']['password'] !== '' && this.data['configuration']['password'] !== null && this.data['configuration']['password'] !== undefined
        && this.data['configuration']['host'] !== '' && this.data['configuration']['host'] !== null && this.data['configuration']['host'] !== undefined
        && this.data['configuration']['port'] !== null && this.data['configuration']['port'] !== undefined
        && this.data['configuration']['protocol'] !== '' && this.data['configuration']['protocol'] !== null && this.data['configuration']['protocol'] !== undefined) {
      if (this.data['configuration']['fromEmailConfigurations'].length > 0) {
        const data = this.platform.adminSettingsData;
        if (data && data['body']) {
          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
          });

          const payload = {};

          const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          payload['shash'] = salt;
          payload['ralam'] = iv;
          const attributes = Object.keys(this.data['configuration']);
          for (const key of attributes) {
            if (key === 'username' || key === 'password' || key === 'host') {
              await this.platform.encryptAttribute(salt, iv, this.passphrase, this.data['configuration'][key], this.keySize, this.iterationCount).then(response => {
                payload[key] = response;
              });
            } else if (key === 'fromEmailConfigurations') {
              payload[key] = [];

              for (const email of this.data['configuration'][key]) {
                const attributes1 = Object.keys(email);
                const obj = JSON.parse(JSON.stringify(email));
                for (const key1 of attributes1) {
                  if (key1 === 'sender_name' || key1 === 'sender_email') {
                    await this.platform.encryptAttribute(salt, iv, this.passphrase, obj[key1], this.keySize, this.iterationCount).then(response => {
                      obj[key1] = response;
                    });
                  }
                }
                payload[key].push(obj);
              }
            } else {
              payload[key] = this.data['configuration'][key];
            }

          }

          let index = 0;
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined && env['name'] !== 'admin') {
              this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response => {
                if (response && response['body']) {
                  for (const env1 of response['body'][0]['environments']) {
                    if (env1 && env1 !== null && env1 !== undefined) {
                      env1['services'].filter(service => {
                        if (service.name === 'Email Configurations') {
                          service['configurations'][this.data['index']] = payload;
                        }
                      });
                    }
                  }
                  this.platform.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).then(resp1 => {
                    index += 1;
                    if (index === data['body'][0]['environments'].length) {
                      this.platform.openSnackBar('Email Configuration updated successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                      });
                      loaderDialog.close();
                      this.dialogRef.close('success');
                    }
                  });
                }
              }, error => {
                loaderDialog.close();
              });
            }
          }
        }
      } else {
        this.platform.openSnackBar('Please configure at least one From Email Address.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.platform.openSnackBar('Please fill all the required attributes.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

}
